<template>
  <tr>
    <td class="drag-handle" style="cursor: grab">
      <i class="fas fa-grip-lines"></i>
    </td>
    <td>
      <div>#{{ position }}</div>
    </td>
    <td>
      <div>{{ category.name }}</div>
    </td>
    <td>
      <div>{{ category.topic.name }}</div>
    </td>
    <td>
      <div v-if="category.enabled">
        <span class="badge badge-success">Activado</span>
      </div>
      <div v-else><span class="badge badge-danger">Desactivado</span></div>
    </td>
    <td>
      <router-link
        class="btn btn-sm btn-edit"
        :to="'/app/blog/category/' + category.UUID"
      >
        <i class="fas fa-edit"></i>
      </router-link>
      <button 
        class="btn btn-outline-danger btn-sm" 
        @click="confirmDelete()"
        :disabled="isDeleting"
      >
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import CategoryService from "@/services/category.service";
import TopicService from "@/services/topic.service";

import Swal from "sweetalert2";

export default {
  name: "CategoryRow",
  props: {
    category: Object,
    position: Number,
  },
  data() {
    return {
      topics: [],
      isDeleting: false,
    };
  },
  methods: {
    async getTopics() {
      this.topics = await TopicService.getAllTopics();
      this.topics = this.topics.data;
      // console.log(this.topics)
    },
    async confirmDelete() {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        html: `Estás a punto de eliminar la categoría <strong>${this.category.name}</strong>. Esta acción no se puede deshacer.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        focusCancel: true
      });

      if (result.isConfirmed) {
        await this.deleteCategory();
      }
    },
    async deleteCategory() {
        this.isDeleting = true;
      
        try {
          const response = await CategoryService.deleteCategory(this.category.UUID);
          
          if (response.status === 200 || response.status === 204) {
            Swal.fire({
              position: "top-end",
              icon: "success",
            title: "Categoría eliminada correctamente",
              showConfirmButton: false,
              timer: 2500,
              backdrop: false,
              toast: true,
            });

            // Wait for toast before refreshing
            setTimeout(() => {
              this.$router.go();
            }, 2500);
          }
        } catch (error) {
          console.error("Error deleting category:", error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo eliminar la categoría',
          });
        } finally {
          this.isDeleting = false;
      }
    },
  },
  created() {
    this.getTopics();
  },
};
</script>
